<template src="./ViewReclaim.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Divider} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ReclaimDetail from "@/components/Shared/ReclaimDetail/ReclaimDetail";
import moment from "moment-timezone";
import {requestReclamosMixin} from "@/api/reclamosApi";

export default {
  name: "ViewReclaim",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    ReclaimDetail
  },
  mixins: [
    ScreenSizeMixin,
    requestReclamosMixin,
    NotifyMixin
  ],
  data: () => ({
    loading: true,
    errored: false,
    inRoute: false,
    model: {
      id: "",
      idcard: "",
      fullname: "",
      address: "",
      email: "",
      phone: "",
      state: "",
      stateCode: 0,
      date: '',
      time: '',
      typeProblem: '',
      detailProblem: '',
    },
  }),
  props: {
    id: {
      type: String,
      required: false
    }
  },
  beforeMount() {
    this.getId()
    this.reclaimRequest()
  },
  computed: {
    getShadow: function () {
      if (this.$route.params.hasOwnProperty('id')) {
        return 'always'
      }
      return 'never'
    }
  },
  methods: {
    getId() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.model.id = this.$route.params.id
        this.inRoute = true
      } else {
        this.model.id = this.id
      }
    },
    reclaimRequest() {
      this.getReclaimView(this.model.id)
        .then(response => {
          this.$log.debug('getReclaimView', this.model.id, response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.convertDataToModel(data)

            this.errored = false
          } else {
            this.messageError(response.data.statusCode)
          }
        })
        .catch(err => {
          this.$log.fatal('getReclaimView', err, this.model.id)
          this.messageError(err.request.status)
        })
        .finally(() => {
          this.loading = false
        })
    },
    convertDataToModel(data = {}) {
      this.model.idcard = data.run
      this.model.fullname = data.nombrecompleto
      this.model.email = data.email
      this.model.address = data.domicilio
      this.model.phone = data.telefono
      this.model.state = data.estado
      this.model.stateCode = data.codigoestado
      this.model.date = moment.utc(data.fecha).local().format("DD-MM-YYYY")
      this.model.time = moment.utc(data.fecha).local().format("h:mm a")
      this.model.typeProblem = data.problema
      this.model.detailProblem = data.reclamo
    },
    messageError(statusCode) {
      this.errored = true
      let message = 'Ocurrió un error inesperado al cargar el reclamo'
      if (statusCode === 404) {
        message = 'El reclamo no existe'
      }
      this.showError(message)
      this.$emit('on-error-close', true)
    },
  }
}
</script>
